import React, { useState, useEffect } from "react";
import axios from "axios";
import NavbarAdminLealtad from "../NavbarAdminLealtad/NavbarAdminLealtad";
import FooterIndex from "../../components/footerHomePage/footerHomePage";

const ListUserProv = () => {
  const [sales, setSales] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_GET_ALL_SUPPLIER_LEALTAD);
      setSales(response.data);
    } catch (error) {}
  };

  return (
    <div className="backgounrdprovlealtad">
      <NavbarAdminLealtad />
      <div className="allboxlistprovadminlealtad">
        <div className="alllistprovlealtad">
          <div className="headerlistprovadminlealtad">
            <p
              id="listprovlealtad"
              className="infoprovlistletterlealtad leftlistprevlealtad firtsborderlealtad"
            >
              Nombre del Comercializador
            </p>
            <p id="listprovlealtad" className="infoprovlistletterlealtad bottonlistprevlealtad">
              Cuit
            </p>
            <p id="listprovlealtad" className="infoprovlistletterlealtad bottonlistprevlealtad">
              Estado
            </p>
            <p
              id="listprovlealtad"
              className="infoprovlistletterlealtad bottonlistprevlealtad lastborderlealtad"
            >
              Tipo
            </p>
          </div>
          {sales.map((sale, index) => (
            <div className="headerlistprovadminlealtad marginlistprovlealtad" key={index}>
              <p id="listprovlealtad" className="infoprovlistletterlealtad leftlistprev2lealtad">
                {sale.nameAndLastName}
              </p>
              <p id="listprovlealtad" className="infoprovlistletterlealtad leftlistprev2lealtad">
                {sale.cuit}
              </p>
              <p id="listprovlealtad" className="infoprovlistletterlealtad bottonlistprev2lealtad">
                {sale.status}
              </p>
              <p id="listprovlealtad" className="infoprovlistletterlealtad bottonlistprev2lealtad">
                {sale.type === "ComercializadorLealtad" ? "Comercializador" : sale.type}
              </p>
            </div>
          ))}
        </div>
      </div>
      <FooterIndex />
    </div>
  );
};

export default ListUserProv;
